import { render, staticRenderFns } from "./SettlementList.vue?vue&type=template&id=e350115e&scoped=true&"
import script from "./SettlementList.vue?vue&type=script&lang=js&"
export * from "./SettlementList.vue?vue&type=script&lang=js&"
import style0 from "./SettlementList.vue?vue&type=style&index=0&id=e350115e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e350115e",
  null
  
)

export default component.exports